import type { QueryClient } from '@tanstack/react-query';

export const invalidatePermissionSensitiveQueries = async (queryClient: QueryClient, refreshCurrentUser = true) => {
  // Resolve changed organisation mappings before refetching office-sensitive choices.
  if (refreshCurrentUser) {
    await queryClient.invalidateQueries({ queryKey: ['users', 'current'] });
  }
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ['users'], predicate: (query) => query.queryKey[1] !== 'current' }),
    ...[
      'trajectories', 'cases', 'dashboard', 'tasks', 'branches', 'organisations', 'companies', 'company-labels',
      'case-dates', 'invoice-references', 'calendar', 'calendar-calendars', 'calendar-events', 'calendar-events-range',
    ].map((key) => queryClient.invalidateQueries({ queryKey: [key] })),
  ]);
};
